var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowInCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41132_29498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00012 0C4.0376 0 0.000329971 4.03744 0.000329971 9.00004C0.000329971 13.9626 4.0376 18 9.00012 18C13.9626 18 18 13.9626 18 9.00004C18 4.03744 13.9626 0 9.00012 0ZM9.00012 16.768C4.71694 16.768 1.23236 13.2833 1.23228 9.00004C1.23228 4.71678 4.71686 1.23211 9.00012 1.23203C13.2833 1.23211 16.7679 4.71677 16.7679 9.00012C16.7679 13.2832 13.2833 16.768 9.00012 16.768Z",
    fill: "var(--color-primary)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.209 5.14558C9.96845 4.90509 9.57839 4.90517 9.33789 5.14558C9.09724 5.38624 9.09724 5.77622 9.33798 6.01687L11.7051 8.38392L4.85036 8.38458C4.51015 8.38466 4.23443 8.66039 4.23443 9.00076C4.23451 9.34096 4.51024 9.61661 4.85044 9.61661L11.7054 9.61595L9.33773 11.9835C9.09716 12.2241 9.09716 12.6142 9.33773 12.8547C9.45806 12.975 9.61568 13.0352 9.77338 13.0352C9.93099 13.0352 10.0886 12.975 10.2089 12.8548L13.6281 9.43567C13.7437 9.32018 13.8086 9.16355 13.8086 9.0001C13.8085 8.83665 13.7436 8.6801 13.6281 8.56438L10.209 5.14558Z",
    fill: "var(--color-primary)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41132_29498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 -1 18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowInCircle);
export default __webpack_public_path__ + "static/media/RightArrowInCircle.40a929a5905f9b7260a2c5b6afae4e14.svg";
export { ForwardRef as ReactComponent };